import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap/dist/js/bootstrap.bundle.min';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'; 
import { PersistGate } from 'redux-persist/integration/react';
import { Suspense } from 'react';
import  {store, persistedStore} from './store';
import './style.css';

import App from './App';
import Spinner from './components/common/Spinner';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistedStore}>
      <Suspense fallback={<div className="az-loading-container"><div className="text-center"><div className="d-flex justify-content-center mb-4"><Spinner size={40}/></div></div></div>}>
      <BrowserRouter  future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
        <App />
      </BrowserRouter>  
      </Suspense>
      </PersistGate>
    </Provider>
  </> 
);